"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectOptionContext = exports.getOptionHtmlId = exports.SelectOptionContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
exports.SelectOptionContext = React.createContext({
    parentMenuId: '',
    isMultiple: false,
});
var getOptionHtmlId = function (menuId, optionValue) { return menuId + "-" + optionValue; };
exports.getOptionHtmlId = getOptionHtmlId;
exports.getSelectOptionContext = helper_1.createContextValueGetter();
